import React from 'react';
import { motion } from 'framer-motion';
export function ScienceHook() {
  return <section className="py-10 px-6 md:px-12 bg-white" data-id="element-59">
      <div className="max-w-4xl mx-auto" data-id="element-60">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="relative p-8 md:p-16 border border-gold/20 bg-cream-dark/30" data-id="element-61">
          {/* Decorative corners */}
          <div className="absolute top-0 left-0 w-8 h-8 border-t border-l border-gold" data-id="element-62"></div>
          <div className="absolute top-0 right-0 w-8 h-8 border-t border-r border-gold" data-id="element-63"></div>
          <div className="absolute bottom-0 left-0 w-8 h-8 border-b border-l border-gold" data-id="element-64"></div>
          <div className="absolute bottom-0 right-0 w-8 h-8 border-b border-r border-gold" data-id="element-65"></div>

          <h2 className="text-xl md:text-2xl font-sans font-light text-charcoal-light text-center mb-8 uppercase tracking-widest" data-id="element-66">
            La Anatomía del Envejecimiento
          </h2>

          <p className="text-2xl md:text-4xl font-serif leading-relaxed text-center text-charcoal" data-id="element-67">
            "El rostro tiene{' '}
            <span className="font-semibold text-gold-dark" data-id="element-68">57 músculos</span>{' '}
            que representan el 80% del volumen facial, pero el 99% de las
            mujeres solo trata la piel{' '}
            <span className="italic text-charcoal-light text-xl md:text-3xl" data-id="element-69">
              (el 20% restante)
            </span>
            ."
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="mt-8 text-center max-w-2xl mx-auto" data-id="element-70">
          <p className="text-lg font-sans text-charcoal-light leading-relaxed" data-id="element-71">
            Este desequilibrio en el cuidado facial conduce a lo que la ciencia
            denomina{' '}
            <strong className="text-charcoal font-semibold" data-id="element-72">
              Atrofia Facial Selectiva
            </strong>
            . Mientras invertimos fortunas en cremas que apenas penetran la
            epidermis, la estructura de soporte subyacente se debilita día tras
            día.
          </p>
        </motion.div>

        {/* Anatomical Image */}
        <motion.figure initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="mt-10 flex flex-col items-center" data-id="element-73">
          <div className="relative border border-gold/20 p-3 md:p-4 bg-cream/50 max-w-2xl w-full" data-id="element-74">
            <img src="https://cdn.magicpatterns.com/uploads/fEE7cCF4UKCvv5ssuathYW/Captura_de_pantalla_2025-09-06_a_la(s)_5.13.57_p.m..png" alt="Mapa de zonas faciales afectadas por la atrofia muscular: frente arrugada, líneas de expresión, entrecejo, arrugas nasogenianas y papada" className="w-full h-auto" data-id="element-75" />
          </div>
          <figcaption className="mt-4 text-xs md:text-sm font-sans text-charcoal-light/60 italic tracking-wide text-center max-w-lg" data-id="element-76">
            Fig. 1 — Zonas de deterioro muscular facial. La atrofia selectiva
            afecta cada área de forma progresiva después de los 40 años.
          </figcaption>
        </motion.figure>
      </div>
    </section>;
}